import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ProjectsState } from '@/redux/projects/projects.types';

import {
  getProjectsReducer,
  removeProjectReducer,
  shareProjectReducer,
  archiveProjectReducer,
  reviveProjectReducer,
  getProjectByIdReducer,
  refreshProjectOnListReducer,
} from '@/redux/projects/projects.reducers';

const initialState: ProjectsState = {
  data: [],
  loading: 'idle',
  error: { name: '', message: '' },
};

const projectsSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    /** Drops a project that no longer exists on the server, e.g. after its removal finished. */
    deleteProject: (state, action: PayloadAction<string>) => {
      state.data = state.data.filter(project => project.projectId !== action.payload);
    },
  },
  extraReducers: builder => {
    getProjectsReducer(builder);
    removeProjectReducer(builder);
    shareProjectReducer(builder);
    archiveProjectReducer(builder);
    reviveProjectReducer(builder);
    getProjectByIdReducer(builder);
    refreshProjectOnListReducer(builder);
  },
});

export const { deleteProject } = projectsSlice.actions;

export default projectsSlice.reducer;
